"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPicker = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindUsers_1 = require("../hooks/useFindUsers");
function toArray(value) {
    return Array.isArray(value)
        ? value
        : typeof value !== 'undefined' && value !== null
            ? [value]
            : [];
}
// compare numbers of both arrays
function arrayEquals(a, b) {
    return (Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every(n => b.includes(n)));
}
const UserPicker = props => {
    const { value: userIds, disabled, multiple, showEmail, includeDeleted = false, hideSupportUsers = false, filterGroupIds, textFieldProps } = props;
    const previousUserIds = (0, react_1.useRef)(toArray(userIds));
    const [search, setSearch] = (0, react_1.useState)('');
    const [users, setUsers] = (0, react_1.useState)([]);
    const [selected, setSelected] = (0, react_1.useState)([]);
    const debouncedSearch = (0, core_ui_1.useDebounce)(search, 300);
    const { data, isLoading, error, get } = (0, useFindUsers_1.useFindUsers)();
    const handleChange = (users, change = true) => {
        var _a, _b, _c, _d;
        if (props.multiple) {
            change ? (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, users) : (_b = props.onSelect) === null || _b === void 0 ? void 0 : _b.call(props, users);
        }
        else {
            const user = users[users.length - 1];
            change ? (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, user) : (_d = props.onSelect) === null || _d === void 0 ? void 0 : _d.call(props, user);
        }
    };
    (0, react_1.useEffect)(() => {
        const params = { includeDeleted, hideSupportUsers };
        if (debouncedSearch) {
            params.search = debouncedSearch;
        }
        if (filterGroupIds && filterGroupIds.length > 0) {
            params.groupIds = filterGroupIds;
        }
        get(params);
    }, [debouncedSearch, filterGroupIds, hideSupportUsers, includeDeleted, get]);
    (0, react_1.useEffect)(() => {
        (data === null || data === void 0 ? void 0 : data.data) && setUsers(data.data);
    }, [data]);
    // if userId changes, reselect user
    (0, react_1.useEffect)(() => {
        const ids = toArray(userIds);
        if (!arrayEquals(previousUserIds.current, ids)) {
            setSelected([]);
            previousUserIds.current = ids;
        }
    }, [userIds]);
    (0, react_1.useEffect)(() => {
        // if no selected user yet
        if (selected.length > 0) {
            return;
        }
        const ids = toArray(userIds);
        const selectedUser = users.filter(user => ids === null || ids === void 0 ? void 0 : ids.some(id => id === user.id));
        if (selectedUser.length === 0) {
            return;
        }
        setSelected(selectedUser);
        handleChange(selectedUser, false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users, userIds]);
    return (react_1.default.createElement(lab_1.Autocomplete, { value: multiple ? selected : selected[0] || null, options: users, disabled: disabled, multiple: multiple, loading: isLoading, getOptionLabel: option => {
            const name = `${option.firstName} ${option.lastName}`;
            return showEmail ? `${name} (${option.email})` : name;
        }, getOptionSelected: option => {
            return toArray(userIds).some(id => id === option.id);
        }, onInputChange: (_, value) => setSearch(value), onChange: (_, value) => {
            const users = toArray(value);
            previousUserIds.current = users.map(user => user.id);
            setSelected(users);
            handleChange(users);
        }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, variant: 'outlined', label: 'Select User', placeholder: 'Choose a User' }, textFieldProps, { error: !!((error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.error)), helperText: (error === null || error === void 0 ? void 0 : error.message) || (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.helperText) }))) }));
};
exports.UserPicker = UserPicker;
exports.default = exports.UserPicker;
//# sourceMappingURL=UserPicker.js.map